import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {PagedResponse} from '@shared/models/paged-response-model';
import {TreeItemNode} from '@shared/models/tree-selector.models';
import {Configuration} from '@shared/models/configuration';
import {FxRateReportModel} from '../models/fx-rate-report.model';

@Injectable()
export class FxRateApiService {

  constructor(private httpClient: HttpClient) {
  }

  getCurrenciesTreeData(reportId: string, currencyType: string): Observable<TreeItemNode[]> {
    const url = Configuration.getConfig('FxRateApi')+ `FxRateReport/GetCurrencyTree?reportId=${reportId}&currencyType=${currencyType}`;
    return this.httpClient.get<TreeItemNode[]>(url);
  }
  getCountriesTreeData(reportId: string, currencyType: string): Observable<TreeItemNode[]> {
    const url = Configuration.getConfig('FxRateApi')+ `FxRateReport/GetCountryTree?reportId=${reportId}&currencyType=${currencyType}`;
    return this.httpClient.get<TreeItemNode[]>(url);
  }
  getFxRateReport(reportId: string): Observable<FxRateReportModel> {
    const url = Configuration.getConfig('FxRateApi')+ `FxRateReport/GetFxRateReport?reportId=${reportId}`;
    return this.httpClient.get<FxRateReportModel>(url);
  }
}


